import cn from 'classnames';
import * as React from 'react';

import Text from 'components/shared/Text';
import { ErrorType } from 'utils/validators';
import { renderError } from 'utils/validators/renderErrors';

import MultiLineEllipsis from '../MultiLineEllipsis';

import s from './AbsoluteError.module.scss';

type AbsoluteErrorProps = {
  className?: string;
  error: ErrorType;
};

const AbsoluteError: React.FC<AbsoluteErrorProps> = ({ className, error }) => {
  const renderedError = renderError(error);

  return (
    <Text size="sm" span className={cn(s.root, className)}>
      <MultiLineEllipsis maxLine={1}>{renderedError}</MultiLineEllipsis>
    </Text>
  );
};

export default React.memo(AbsoluteError);
